import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaGithub,
} from "react-icons/fa";

import "./footer.css";
// import logo from "../../assets/Images/logp.png";

const Footer = () => {
  return (
    <footer className="sc-footer">
      <Container fluid>
        <Row className="align-items-start">

          {/* Left */}
          <Col lg={5} md={6} className="sc-footer-left">
            <h3>
              Sell Cart Pvt Ltd
              {/* <img src={logo} alt="Sell Cart" className="sc-logo" /> */}
            </h3>
            <p>
              <span>About the company</span>
              E-commerce (electronic commerce) is the buying and selling
              of goods and services, or the transmitting of funds or data,
              over an electronic network, primarily the internet.
            </p>

            <div className="sc-social">
              <a href="#"><FaFacebookF /></a>
              <a href="#"><FaTwitter /></a>
              <a href="#"><FaLinkedinIn /></a>
              <a href="#"><FaGithub /></a>
            </div>
            

            <p className="sc-copyright">
              Sell Cart Pvt Ltd © 2015
            </p>
          </Col>

          {/* Center */}
          <Col lg={3} md={12} className="sc-about">
                        <h3>Quick Links</h3>      

          <div className="sc-links">
              <a href="#"></a>
              <a href="#">Home</a> <br/>
              <a href="#">Student Login</a><br/>
              <a href="#">Business Login</a><br/>
              <a href="#">About</a><br/>
              {/* <a href="#">Pages</a> */}
              <a href="#">Contact</a>

            </div>
            
          </Col>

          {/* Right */}

           <Col lg={4} md={6} className="sc-contact">
           <h3> Contect Us </h3>
            <div>
              <FaMapMarkerAlt />
              <p>
                <span>WJ62+GCH, 3rd Cross Rd, Industrial Area, BTM Layout 2nd Stage</span>
                 BTM Layout, Bengaluru, Karnataka 560076
              </p>
            </div>

            <div>
              <FaPhone />
              <p>+91 86081 45177</p>
            </div>

            <div>
              <FaEnvelope />
              <p>
                <a href="mailto:webonespark@gmail.com">
                  webonespark@gmail.com
                </a>
              </p>
            </div>
          </Col>

          

        </Row>
      </Container>
    </footer>
  );
};

export default Footer;